<script>
	export let shelf;
	export let books;
	export let noCover;
	export let t;
	import Book from './book.svelte';
	import ShelfIcon from './shelf-icon.svelte';
</script>

<h2 class="shelf-header">
	<span class="shelf-name"><ShelfIcon /> { shelf.name } <span class="book-count">{shelf.bookIds.length} {t['shelfCountLabel']}{shelf.bookIds.length > 1 ? 's':''}<span></span>
</h2>
<div class="books">
{#each shelf.bookIds as bookId}
	<Book book={ books.find(({id}) => id == bookId) } {noCover} />
{/each}
</div>

<style>
	.shelf-header {
		position: relative;
		font-size: 15px;
		margin: 10px 12px 15px;
	}
	.shelf-header:before {
		content: " ";
		position: absolute;
		border-top: 1px solid #e1e1e1;
		width: 100%;
		top: 56%;
		height: 0;
		z-index: -1;
	}
	.shelf-name {
		background-color: #fff;
		padding-right: 10px;
		font-size: 0.95em;
		font-weight: 700;
	}
	.book-count {
		font-size: 13px;
		font-weight: normal;
		margin-left: 8px;
		color: #666;
	}
	.books {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
	}
	@media (max-width: 400px) {
		.shelf-header:before {
			display: none;
		}
	}
	@media (max-width: 355px) {
		.books {
			flex-wrap: no-wrap;
			justify-content: center;
		}
	}
</style>